export default {
  async bakeryAuth(mail, callbackURL) {
    console.log(mail);
    console.log(callbackURL);
    return Promise.resolve(true);
  },
};
